import { LvLogResult } from "interface/carenet/lv/types"
import { distinct } from "shared/util"

export const lvVisit = (r: LvLogResult | undefined) => {
	if (!r) return { code: '00', name: '未視聴' }
	if (r.broadcastDate) {
		if (r.bonusEnqueteDate || r.clientEnqueteDate) return { code: '41', name: '視聴+EQ' }
		return { code: '40', name: '視聴' }
	} else if (r.ondemandDate) {
		if (r.bonusEnqueteDate || r.clientEnqueteDate) return { code: '31', name: 'OD視聴+EQ' }
		return { code: '30', name: 'OD視聴' }
	} else {
		if (r.bonusEnqueteDate || r.clientEnqueteDate) return { code: '20', name: 'EQのみ' }
		if (r.reserveDate) return { code: '10', name: '予約' }
		return { code: '00', name: '未視聴' }
	}
}

export const lvDuration = (
	r: LvLogResult | undefined
) => {
	if (!r?.duration) return undefined
	const totalTime = r.duration
	if (totalTime < 60) return { code: '01', name: '1分未満' }
	if (totalTime < (60 * 10)) return { code: '10', name: '10分未満' }
	if (totalTime < (60 * 30)) return { code: '30', name: '30分未満' }
	if (totalTime < (60 * 60)) return { code: '60', name: '60分未満' }
	if (totalTime < (60 * 90)) return { code: '90', name: '90分未満' }
	return { code: '99', name: '90分以上' }
}

export const lvUserAgentCategory = (r: LvLogResult | undefined) => r?.userAgent?.category?.map((category) => ({ code: category, name: category }))
export const lvUserAgentOS = (r: LvLogResult | undefined) => r?.userAgent?.os?.map((os) => ({ code: os, name: os }))
export const lvUserAgentBrowser = (r: LvLogResult | undefined) => r?.userAgent?.name?.map((name) => ({ code: name, name: name }))

export const lvRefererDomain = (r: LvLogResult | undefined) => {
	if (!r?.referer) return undefined
	const domainList = distinct(r.referer.map((url) => {
		try {
			if (!url) return undefined
			return new URL(url)?.host
		} catch (e) {
			console.log('failed to get domain. invalid url: ' + url, e)
			return undefined
		}
	}))
	return domainList.flatMap((domain) => domain ? { code: domain, name: domain } : [])
}
export const lvRefererLinkFrom = (r: LvLogResult | undefined) => {
	if (!r?.referer) return undefined
	const linkFromList = distinct(r.referer.map((url) => {
		try {
			if (!url) return undefined
			return new URL(url)?.searchParams.get("linkfrom")
		} catch (e) {
			console.log('failed to get linkfrom. invalid url: ' + url, e)
			return undefined
		}
	}))
	return linkFromList.flatMap((referer) => referer ? { code: referer, name: referer } : [])
}

export const lvLinkFrom = (r: LvLogResult | undefined) => r?.linkFrom?.map((linkFrom) => ({ code: linkFrom, name: linkFrom }))
